import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Scrollbars } from 'react-custom-scrollbars';
import { usePageContext } from '../Provider';
/**
 * @extends {React.Component<import('./types').SideBarLayoutProps & import('@material-ui/core').WithStyles<typeof styles, true>> }
 */

var SideBarLayout =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SideBarLayout, _React$Component);

  function SideBarLayout() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SideBarLayout);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SideBarLayout)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      sidebarCollapsed: false
    };

    _this.onCollapseSidebar = function () {
      return _this.setState({
        sidebarCollapsed: true
      });
    };

    _this.onExpandSidebar = function () {
      return _this.setState({
        sidebarCollapsed: false
      });
    };

    _this.renderSidebarScrollView = function (props) {
      var sidebarClasses = 'sidebar ' + _this.props.classes.sidebar;
      if (!_this.state.sidebarCollapsed) sidebarClasses += ' ' + _this.props.classes.styledSidebar;
      return React.createElement("div", Object.assign({}, props, {
        className: sidebarClasses
      }));
    };

    _this.renderContentScrollView = function (props) {
      var _this$props = _this.props,
          classes = _this$props.classes,
          contentNoSpacing = _this$props.contentNoSpacing;
      var contentClass = contentNoSpacing ? classes.contentNoSpacing : classes.content;
      return React.createElement("div", Object.assign({}, props, {
        className: 'content ' + contentClass
      }));
    };

    _this.renderCustomScrollbar = function (_ref) {
      var style = _ref.style,
          props = _objectWithoutProperties(_ref, ["style"]);

      return React.createElement("div", Object.assign({}, props, {
        style: _objectSpread({}, style, {
          cursor: 'pointer',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 5,
          borderRadius: 3
        })
      }));
    };

    return _this;
  }

  _createClass(SideBarLayout, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (nextState.sidebarCollapsed !== this.state.sidebarCollapsed) return true;
      if (this.props !== nextProps.pageContext) return true;
      if (nextProps.renderContent && nextProps.SidebarComponent) return false;
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          theme = _this$props2.theme,
          SidebarComponent = _this$props2.SidebarComponent,
          sidebar = _this$props2.sidebar,
          content = _this$props2.content,
          renderContent = _this$props2.renderContent,
          pageContext = _this$props2.pageContext,
          noToolbar = _this$props2.noToolbar;
      var sidebarCollapsed = this.state.sidebarCollapsed;
      var style = {
        top: 0
      };
      var insertionStyle = {
        top: 0,
        bottom: 0,
        right: 0,
        width: 0
      };
      if (pageContext.navBar) style.top = theme.common.Page.NavBar.style.height;
      if (!noToolbar && pageContext.toolBar) style.top += theme.common.Page.ToolBar.style.height;

      if (pageContext.insertion) {
        style.right = pageContext.insertion.width;
        insertionStyle.width = pageContext.insertion.width;
        insertionStyle.top = style.top;
      }

      return React.createElement("div", {
        className: classes.root,
        style: style
      }, React.createElement(Grid, {
        className: classes.layout,
        spacing: 0,
        container: true,
        direction: "row",
        justify: "space-between",
        alignContent: "stretch"
      }, React.createElement(Grid, {
        item: true,
        style: {
          width: sidebarCollapsed ? theme.common.properties.collapsedWidth : theme.common.properties.width
        },
        className: classes.sidebarWrapper
      }, React.createElement(Scrollbars, {
        autoHide: true,
        renderView: this.renderSidebarScrollView
      }, sidebar ? sidebar : React.createElement(SidebarComponent, {
        collapsed: sidebarCollapsed,
        onCollapse: this.onCollapseSidebar,
        onExpand: this.onExpandSidebar
      }))), React.createElement(Grid, {
        item: true,
        xs: true
      }, React.createElement(Scrollbars, {
        renderView: this.renderContentScrollView,
        renderThumbVertical: this.renderCustomScrollbar,
        renderThumbHorizontal: this.renderCustomScrollbar
      }, renderContent ? renderContent() : content, pageContext.insertion && React.createElement("div", {
        className: classes.insertion,
        style: insertionStyle
      }, pageContext.insertion.children)))));
    }
  }]);

  return SideBarLayout;
}(React.Component);

var styles = function styles(theme) {
  return {
    root: {
      flexGrow: 1,
      bottom: 0,
      position: 'absolute',
      top: theme.common.Page.NavBar.style.height,
      right: 0,
      left: 0,
      backgroundColor: theme.common.background.defaultContent
    },
    layout: {
      height: '100%',
      marginTop: 0
    },
    sidebar: {// maxHeight: '100%',
      // overflow: 'auto',
    },
    insertion: {
      position: 'fixed'
    },
    sidebarWrapper: {
      borderRight: '1px solid #d0d0d0',
      backgroundColor: theme.common.background.defaultSidebar
    },
    styledSidebar: {},
    content: {
      marginLeft: theme.spacing(3),
      marginRight: theme.spacing(3),
      maxHeight: '100%',
      overflow: 'auto !important'
    },
    contentNoSpacing: {
      maxHeight: '100%',
      overflowX: 'hidden!important',
      overflowY: 'scroll!important'
    }
  };
};

SideBarLayout.defaultProps = {
  sidebarCollapsed: false,
  noToolbar: false,
  pageContext: {}
};

var SideBarLayoutPageAware = function SideBarLayoutPageAware(props) {
  var pageContext = usePageContext();
  return React.createElement(SideBarLayout, Object.assign({
    pageContext: pageContext
  }, props));
};

export default withStyles(styles, {
  withTheme: true,
  name: 'ECSideBarLayoutPageAware'
})(SideBarLayoutPageAware);